import * as moment from "moment";
import * as React from "react";
import app from "../../core/application";
import { sendRequest } from "../../helpers/ajax";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMessageTotalsByMonthRequest from "../../types/IMessageTotalsByMonthRequest";
import IMessageTotalsByMonthResponse from "../../types/IMessageTotalsByMonthResponse";
import IResponse from "../../types/IResponse";
import Dashboard from "./Dashboard";

interface IDashboardState {
    messageTotalsByMonth: IMessageTotalsByMonthResponse[];
    loading: boolean;
}


class DashboardContainer extends React.Component<ITranslationProps, IDashboardState> {

    private unmounting: boolean = false;

    constructor(props: ITranslationProps) {
        super(props);

        this.state = {
            messageTotalsByMonth: [],
            loading: false
        };
    }

    public componentWillUnmount(){
        this.unmounting = true;
    }

    public componentDidMount() {
        // Note we are not using await, this is on purpose, we don't have to wait
        // for this data to be loaded before displaying the page
        this.getMessageTotalsByMonth();
    }

    public render() {
        return (
            <Dashboard messageTotalsByMonth={this.state.messageTotalsByMonth} loading={this.state.loading}
                userSession={app().userSession} />
        );
    }

    private async getMessageTotalsByMonth() {

        this.setState({ loading: true });

        // Hard coded to show 6 months of data, date filter controls can be added in the future
        const request: IMessageTotalsByMonthRequest = {
            startDate: moment().add(-6, "months").format(),
            endDate: moment().format(),
        };

        const result = await sendRequest<IResponse<IMessageTotalsByMonthResponse[]>>("/api/MessageStatistics/GetTotalsByMonth", "POST", request);

        if (this.unmounting) { return; }

        if (result && result.success) {
            this.setState({ messageTotalsByMonth: result.payload, loading: false });
        } else {
            this.setState({ messageTotalsByMonth: [], loading: false });
        }
    }

}

export default translateComponent(DashboardContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardContainer.tsx